import { ContentfulAsset, ContentfulSideBySide } from '@jbhi-fi/apis/src/contentful/types';
import { SideBySideProps } from '../../SideBySide/SideBySide';
import { AssetTransformer } from './AssetTransformer';
import { ButtonTransformer } from './ButtonTransformer';
import { palette } from '@jbhi-fi/lanyard-ui/themes';

const isAssetVideo = (asset: ContentfulAsset) => asset.fields?.file.contentType === 'video/mp4';

export abstract class SideBySideTransformer {
  static toSideBySideProps = (entry: ContentfulSideBySide): SideBySideProps => {
    const isButtonLinkType = entry.fields?.ctaLink?.fields?.type === 'Link' && !entry.fields?.ctaLink?.fields?.icon;
    const ctaButtonProps =
      entry.fields?.ctaLink != null
        ? isButtonLinkType
          ? {
              asLink: true,
              ...ButtonTransformer.toGoToLinkProps(entry.fields?.ctaLink),
            }
          : {
              asLink: false,
              ...ButtonTransformer.toLanyardButtonProps(entry.fields?.ctaLink),
            }
        : undefined;

    return {
      heading: entry.fields?.heading,
      youTubeProps: entry.fields?.youTube?.fields ? { videoUrl: entry.fields.youTube.fields.url } : undefined,
      imageProps:
        entry.fields?.imageOrVideo && !isAssetVideo(entry.fields.imageOrVideo)
          ? AssetTransformer.toContentfulImageProps(entry.fields.imageOrVideo)
          : undefined,
      videoProps:
        entry.fields?.imageOrVideo && isAssetVideo(entry.fields.imageOrVideo)
          ? AssetTransformer.toVideoPlayerProps(entry.fields.imageOrVideo)
          : undefined,
      tagProps: entry.fields?.tag
        ? {
            label: entry.fields.tag,
            palette: { background: palette.primary.main },
          }
        : undefined,
      isReversed: entry.fields?.assetPosition === 'Right',
      ctaButtonProps,
      body: entry.fields?.body,
    };
  };
}
